(function () {
  'use strict';

  function track(name, extra) {
    var payload = Object.assign({ page_location: location.href }, extra || {});
    try { if (window.gtag) gtag('event', name, payload); } catch (e) {}
    try { if (window.fbq) fbq('trackCustom', name, payload); } catch (e) {}
  }

  // 1. Page view
  track('studio_page_view');

  // 2. Clics sur boutons taggés data-event
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-event]');
    if (el) track(el.getAttribute('data-event'));
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('livacils-studio-active');

    // 3. Fade-in au scroll
    var reveals = document.querySelectorAll('.livacils-reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (n) { io.observe(n); });
    } else {
      reveals.forEach(function (n) { n.classList.add('is-visible'); });
    }

    // 4. Track affichage du widget Planity (une fois)
    var widget = document.getElementById('livacils-planity-widget');
    if (widget && 'IntersectionObserver' in window) {
      var seen = false;
      var wio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !seen) {
            seen = true;
            track('planity_widget_view');
            wio.disconnect();
          }
        });
      }, { threshold: 0.3 });
      wio.observe(widget);
    }

    // 5. Sticky CTA mobile injecté si absent (cas où le thème ne le rend pas via section)
    if (!document.querySelector('.livacils-studio-sticky-cta') && !document.querySelector('[data-studio-sticky]')) {
      var sticky = document.createElement('a');
      // Sur la page hub, #reservation existe (section booking). Sur les sous-pages, #prestations.
      sticky.href = document.getElementById('reservation') ? '#reservation' : '#prestations';
      sticky.className = 'livacils-studio-sticky-cta';
      sticky.setAttribute('data-event', 'studio_booking_click');
      sticky.textContent = 'Réserver au Studio';
      document.body.appendChild(sticky);
    }

    // 6.0. Intercept Studio "Payer en totalité" forms : utilise window.LiveCart.addToCart du thème
    //      pour ajouter au panier en AJAX + ouvrir le drawer existant. Fallback : POST natif vers /cart/add.
    document.querySelectorAll('[data-studio-buy-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (!button || button.dataset.loading === 'true') return;
        button.dataset.loading = 'true';

        var variantId = parseInt(form.querySelector('input[name="id"]').value, 10);
        var qty = parseInt((form.querySelector('input[name="quantity"]') || { value: 1 }).value, 10) || 1;
        var productTitle = button.dataset.productTitle || '';

        var onDone = function () {
          button.dataset.loading = 'false';
          track('studio_buy_added', { product_title: productTitle, variant_id: variantId });
        };
        var onErr = function (err) {
          console.error('[Studio buy] add-to-cart error', err);
          button.dataset.loading = 'false';
          // Fallback : POST natif vers /cart/add (Shopify redirige vers /cart)
          form.submit();
        };

        // Préféré : appel direct au cart-drawer du thème
        if (window.LiveCart && typeof window.LiveCart.addToCart === 'function') {
          try {
            var result = window.LiveCart.addToCart(variantId, qty);
            if (result && typeof result.then === 'function') {
              result.then(onDone).catch(onErr);
            } else {
              onDone();
            }
            return;
          } catch (err) {
            onErr(err);
            return;
          }
        }

        // Fallback : fetch direct vers l'AJAX cart API + open drawer manuel
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          var drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          } else {
            window.location.href = '/cart';
          }
          onDone();
        })
        .catch(onErr);
      });
    });

    // 6. Before/After interactive slider (clip-path based via --ba-pos CSS var)
    document.querySelectorAll('[data-ba]').forEach(function (figure) {
      var range = figure.querySelector('[data-ba-range]');
      var frameEl = figure.querySelector('[data-ba-frame]');
      if (!range || !frameEl) return;

      var trackedInteraction = false;
      function apply(value) {
        var v = Math.max(0, Math.min(100, value));
        figure.style.setProperty('--ba-pos', v + '%');
        range.setAttribute('aria-valuenow', Math.round(v));
        if (!trackedInteraction) {
          trackedInteraction = true;
          var title = figure.querySelector('.livacils-studio-ba__title');
          track('studio_ba_interact', { ba_title: title ? title.textContent : '' });
        }
      }

      range.addEventListener('input', function () { apply(parseFloat(range.value)); });

      var dragging = false;
      function pointerToPct(clientX) {
        var rect = frameEl.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        range.value = pct;
        apply(pct);
      }
      frameEl.addEventListener('mousedown', function (e) {
        dragging = true;
        pointerToPct(e.clientX);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) pointerToPct(e.clientX);
      });
      document.addEventListener('mouseup', function () { dragging = false; });

      frameEl.addEventListener('touchstart', function (e) {
        if (e.touches.length) pointerToPct(e.touches[0].clientX);
      }, { passive: true });
      frameEl.addEventListener('touchmove', function (e) {
        if (e.touches.length) pointerToPct(e.touches[0].clientX);
      }, { passive: true });
    });
  });
})();
